module.exports = __webpack_public_path__ + "img/neox-icon.57852a04.svg";